module.exports = __webpack_public_path__ + "static/53invgde-dafbb64767e77b9e9c4fcd39c1ba3dc5.gif";